import React, {useEffect, useReducer} from 'react';
import userReducer from "./userReducer";
import useAuthentication from "../../hooks/useAuthentication";
import UserContext from "./UserContext";


const UserState = (props) => {
    
    const user = useAuthentication();

    const init = () => {
        return JSON.parse(localStorage.getItem("user")) || {logged:false}
    }

    const [state, dispatch] = useReducer(userReducer, {}, init);


    useEffect(() => {
        localStorage.setItem("user", JSON.stringify(state));
    }, [state]);


    // Functions
    const login = () => {
        dispatch({
            type: "LOGIN",
            payload: user
        })
        localStorage.setItem("user", JSON.stringify(state));
    }

    const logout = () => {
        dispatch({
            type: "LOGOUT"
        })
    }
    
    return (
        <UserContext.Provider value = {{
            user,
            logged: state.logged,
            login,
            logout
        }}>
            {props.children}
        </UserContext.Provider>
    );
}
 
export default UserState;